module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-07.15518dba.png";